import { render, staticRenderFns } from "./table.vue?vue&type=template&id=968ca72c&scoped=true&"
import script from "./table.vue?vue&type=script&lang=js&"
export * from "./table.vue?vue&type=script&lang=js&"
import style0 from "./table.vue?vue&type=style&index=0&lang=css&"
import style1 from "./table.vue?vue&type=style&index=1&id=968ca72c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968ca72c",
  null
  
)

export default component.exports